import { toDollars } from "../../../helpers/currencies";
import { RollingCubeMotion } from "../RollingCube";
import EmployerStatSummary, {
  EmployerStatSummaryDisplayProps,
} from "./EmployerStatSummary";

const EmployerAnnualisedSavingsStat = ({
  totalAnnualSavings,
  totalAnnualPayrolTaxSavings,
  showTitle,
  navigateOnClick,
  config,
  showAlternate,
  motion,
}: {
  totalAnnualSavings: number;
  totalAnnualPayrolTaxSavings: number;
  showAlternate?: boolean;
  motion?: RollingCubeMotion;
} & EmployerStatSummaryDisplayProps) => {
  return (
    <EmployerStatSummary
      title="Annualised Employee Savings"
      imageUrl="/analytics/savings.png"
      value={toDollars(totalAnnualSavings, 0)}
      page="employerViewAnalyticsAnnualSavings"
      alternate={{
        title: "Annualised Payroll Tax Savings^",
        value: toDollars(totalAnnualPayrolTaxSavings, 0),
        valueColor: "primary.main",
        page: "employerViewAnalyticsPayrollTaxSavingsSummaries",
      }}
      showAlternate={showAlternate}
      motion={motion}
      showTitle={showTitle}
      navigateOnClick={navigateOnClick}
      config={config}
    />
  );
};

export default EmployerAnnualisedSavingsStat;
